import { Link } from "react-router-dom";
import { HiCheckCircle } from "react-icons/hi";

const formatMoeda = (valor) =>
  `R$ ${Number(valor).toFixed(2).replace(".", ",")}`;

const recursosGratis = [
  "3 links ativos",
  "5 MB de armazenamento",
  "Cadastro dos primeiros produtos",
  "Acesso a página de ajuda",
  "Sem suporte via WhatsApp",
];

const recursosPagos = [
  "10 links ativos",
  "200 MB de armazenamento",
  "Suporte via WhatsApp",
  "Análise de engajamento no dashboard",
  "Vitrine pronta para compartilhar",
];

const planos = [
  {
    id: "gratis",
    nome: "Grátis",
    descricao: "Para criar sua primeira vitrine e testar o fluxo no seu ritmo.",
    valor: 0,
    periodo: "/sempre",
    totalTexto: "Sem cobrança e sem Stripe.",
    destaqueTexto: "Comece agora",
    recursos: recursosGratis,
  },
  {
    id: "mensal",
    nome: "Mensal",
    descricao: "Flexibilidade total para vender com a Vintree.",
    valor: 35,
    periodo: "/mês",
    totalTexto: "Cobrança mensal de R$ 35,00",
    destaqueTexto: "Cancele quando quiser",
    recursos: recursosPagos,
  },
  {
    id: "trimestral",
    nome: "Trimestral",
    descricao: "Mais previsibilidade para manter sua vitrine ativa.",
    valor: 33,
    periodo: "/mês",
    totalTexto: "Total de R$ 99,00 a cada 3 meses",
    destaqueTexto: "Plano equilibrado",
    recursos: recursosPagos,
  },
  {
    id: "semestral",
    nome: "Semestral",
    descricao: "Bom custo-benefício para quem usa a vitrine toda semana.",
    valor: 31,
    periodo: "/mês",
    totalTexto: "Total de R$ 186,00 a cada 6 meses",
    destaque: true,
    destaqueTexto: "Mais escolhido",
    recursos: recursosPagos,
  },
  {
    id: "anual",
    nome: "Anual",
    descricao: "O menor valor mensal para quem já organizou a operação.",
    valor: 29,
    periodo: "/mês",
    totalTexto: "Total de R$ 348,00 por ano",
    destaqueTexto: "Melhor valor mensal",
    recursos: recursosPagos,
  },
];

const PlanosSection = () => {
  return (
    <section className="py-24 px-6 sm:px-12 text-gray-900">
      <div className="max-w-7xl mx-auto text-center">
        <h3 className="mt-5 text-sm font-semibold uppercase tracking-wide text-gray-800/80">
          Planos para cada momento da sua loja
        </h3>
        <h2 className="mt-4 text-4xl sm:text-5xl font-bold tracking-tight leading-tight text-gray-900">
          Comece gratuitamente
        </h2>
        <p className="mt-6 text-lg leading-8 text-gray-800/90 max-w-2xl mx-auto">
          Crie sua vitrine, cadastre seus primeiros produtos e conheca a Vintree
          no seu ritmo.
        </p>

        <div className="mt-14 grid grid-cols-1 md:grid-cols-2 xl:grid-cols-5 gap-5">
          {planos.map((plano) => (
            <Link
              key={plano.id}
              to="/cadastrar"
              className={`relative flex h-full flex-col rounded-lg border bg-white p-5 text-left shadow-sm transition-transform duration-200 hover:-translate-y-1 hover:shadow-md focus:outline-none focus:ring-2 focus:ring-purple-400 ${
                plano.destaque
                  ? "border-purple-500 ring-1 ring-purple-200"
                  : "border-gray-200"
              }`}
            >
              {plano.destaque ? (
                <div className="absolute -top-3 left-5 rounded-full bg-purple-700 px-3 py-1 text-xs font-semibold text-white shadow-sm">
                  Recomendado
                </div>
              ) : null}

              <div>
                <h3 className="text-xl font-semibold text-gray-900">{plano.nome}</h3>
                <p className="mt-2 min-h-[3.5rem] text-sm leading-6 text-gray-500">
                  {plano.descricao}
                </p>
              </div>

              <div className="mt-6">
                <div className="flex items-baseline gap-2 flex-wrap">
                  <span className="text-3xl font-bold tracking-tight text-purple-700">
                    {formatMoeda(plano.valor)}
                  </span>
                  <span className="text-sm font-medium text-gray-500">
                    {plano.periodo}
                  </span>
                </div>
                <p className="mt-3 min-h-[2.5rem] text-sm text-gray-600">
                  {plano.totalTexto}
                </p>
              </div>

              <ul className="mt-5 space-y-3 text-sm text-gray-700">
                {plano.recursos.map((recurso) => (
                  <li key={recurso} className="flex gap-2">
                    <HiCheckCircle className="mt-0.5 h-4 w-4 flex-none text-purple-600" />
                    <span>{recurso}</span>
                  </li>
                ))}
              </ul>

              <div className="mt-auto pt-6">
                <div className="inline-flex items-center rounded-full bg-purple-50 px-3 py-1 text-xs font-medium text-purple-700">
                  {plano.destaqueTexto}
                </div>
              </div>
            </Link>
          ))}
        </div>

        <p className="mt-6 text-sm text-gray-700/90">
          O plano grátis fica ativo sem pagamento. Quando sua loja precisar de mais
          links, espaço ou suporte, faça upgrade para um plano pago.
        </p>
      </div>
    </section>
  );
};

export default PlanosSection;
